export const STEPPER_FORM = 'STEPPER_FORM';
export const HEADER = 'HEADER';
export const FOOTER = 'FOOTER';
export const LEGACY_AUTH = 'LEGACY_AUTH';
export const PHONE_AUTH = 'PHONE_AUTH';
export const AADHAR = 'AADHAR';
export const PAN = 'PAN';
export const COPILOT = 'COPILOT';
export const RECRUITMENT = 'RECRUITMENT';
export const DOCUMENT_UPLOADER = 'DOCUMENT_UPLOADER';
export const SESSION_EXPIRY = 'SESSION_EXPIRY';
export const LOADER = 'LOADER';
export const ASSESSMENT = 'ASSESSMENT';

export const SAMPLE = 'SAMPLE';
export const SAMPLE_DIALOG = 'SAMPLE_DIALOG';
export const SAMPLE_FORM = 'SAMPLE_FORM';
export const SAMPLE_FORM_PACKAGE = 'SAMPLE_FORM_PACKAGE';
export const PROGRESSIVE_STEPPER = 'PROGRESSIVE_STEPPER';
export const PROGRESSIVE_STEPPER_DIALOG = 'PROGRESSIVE_STEPPER_DIALOG';
export const PROGRESSIVE_STEPPER_FORM = 'PROGRESSIVE_STEPPER_FORM';
export const PROGRESSIVE_STEPPER_ASSESSMENT = 'PROGRESSIVE_STEPPER_ASSESSMENT';
export const SUPER_SET = 'SUPER_SET';
export const AUTH = 'AUTH';
export const COPILOT_RETRIES = '11';
export const COPILOT_FOLLOW_UP_QUESTIONS = '11';
export const COPILOT_MODAL = 'COPILOT_MODAL';
export const COPILOT_V2 = 'COPILOT_V2';
export const UI_BUILDER_HOME = 'UI_BUILDER_HOME';
export const UI_BUILDER = 'UI_BUILDER';
export const UI_RUNNER = 'UI_RUNNER';
export const UI_SELFSERVE_HOME = 'UI_SELFSERVE_HOME';
export const UI_SELFSERVE_RUNNER = 'UI_SELFSERVE_RUNNER';
export const USER_PROFILE = 'USER_PROFILE';
export const DASHBOARD = 'DASHBOARD';
export const USER_360 = 'USER_360';
export const USER_ACTION_DIALOG = 'USER_ACTION_DIALOG';
export const WORKFLOW_FORM = 'WORKFLOW_FORM';
export const MOCK_HOSTAPP = 'MOCK_HOSTAPP';
export const VISUAL_TESTING = 'VISUAL_TESTING';
export const PROGRESSIVE_STEPPER_WITH_BREADCRUMBS =
  'PROGRESSIVE_STEPPER_WITH_BREADCRUMBS';
export const ABC_SELECT_CUSTOM = 'ABC_SELECT_CUSTOM';
export const SPG_WIDGET = 'SPG_WIDGET';
export const SPG_WIDGET_MODULE_CODE = 'SPG_WIDGET_MODULE_CODE';
export const SPG_WIDGET_MODULE_ITEM_CODE = 'SPG_WIDGET_MODULE_ITEM_CODE';
export const SPG_WIDGET_ITEM_CODE = 'SPG_WIDGET_ITEM_CODE';
export const REVYRE_LIST = 'REVYRE_LIST';
export const REVYRE_WORKFLOW_LIST = 'REVYRE_WORKFLOW_LIST';
export const REVYRE_DETAILS = 'REVYRE_DETAILS';
export const REVYRE_WORKFLOW_DETAILS = 'REVYRE_WORKFLOW_DETAILS';
export const REVYRE_FILTERS = 'REVYRE_FILTERS';
export const REVYRE_FORM = 'REVYRE_FORM';
export const COPILOT_AGENT = 'COPILOT_AGENT';
export const REVYRE_AGENT = 'REVYRE_AGENT';
export const AGENT_SUMMARISE = 'AGENT_SUMMARISE';
export const REVYRE_HELLO_CARDS = 'REVYRE_HELLO_CARDS';
export const BREADCRUMB = 'BREADCRUMB';
export const LEGACY_WEB_INTERFACE = 'LEGACY_WEB_INTERFACE';
export const HOME_DASHBOARD = 'HOME_DASHBOARD';
export const SIDEBAR = 'SIDEBAR';
export const NAVBAR = 'NAVBAR';
export const HELLO_CARDS = 'HELLO_CARDS';
export const VYMOBANNER = 'VYMOBANNER';
export const DDP_DETAILS = 'DDP_DETAILS';
export const GENERIC_LIST = 'GENERIC_LIST';
export const FORM_AUTH = 'FORM_AUTH';
export const REVYRE_NOTIFICATION = 'REVYRE_NOTIFICATION';
export const NAVIGATION_V2 = 'NAVIGATION_V2';
export const FILTERS = 'FILTERS';
export const PERFORMANCE_LEADERBOARD = 'PERFORMANCE_LEADERBOARD';
export const PERFORMANCE_DASHBOARD = 'PERFORMANCE_DASHBOARD';
export const DETAILS_360 = 'DETAILS_360';
export const REVYRE_DETAILS_360 = 'REVYRE_DETAILS_360';
export const REVYRE_WORKFLOW_DETAILS_360 = 'REVYRE_WORKFLOW_DETAILS_360';
export const AGENT_DOCS = 'AGENT_DOCS';
export const POLICY_DETAILS = 'POLICY_DETAILS';
export const AUTH_REDIRECTION = 'AUTH_REDIRECTION';
